import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What tools will I use to build Android apps?",
    
    description:
      "You will primarily use Android Studio as the official development environment. Alongside it, you’ll work with Kotlin or Java, XML layouts, Firebase backend services, and testing tools for debugging apps on virtual and physical devices.",
  },
  {
    title: "What kind of projects will I build during the course?",
   
    description:
      "You’ll build projects like weather apps, note apps, login systems, e-commerce apps, and chat applications. These hands-on projects help you understand real app workflows and prepare you to publish fully functional apps on the Google Play Store.",
  },
  {
    title: "Which language should I learn — Kotlin or Java?",
   
    description:
      "Kotlin is the preferred Android language because it’s modern, concise, and officially supported by Google. However, Java remains widely used in legacy and enterprise applications, so learning either language provides strong value for Android development.",
  },
  {
    title: "What industries use Android developers?",
    
    description:
      "Android apps are used in nearly every industry, including e-commerce, education, healthcare, fitness, banking, travel, logistics, productivity, and entertainment. This widespread adoption creates consistently high demand for skilled Android developers across the job market.",
  },
  {
    title: "Do Android developers need backend knowledge?",
    
    description:
      "Basic backend knowledge is useful since many apps depend on APIs and remote databases. Understanding Node.js, Firebase, or simple REST APIs helps you integrate servers and makes you a more complete Android developer.",
  },
];

const NewsSection = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default NewsSection;
